import React, {
    useState
} from "react";
import {
    useNavigate
} from "react-router-dom";
import {
    IoClose
} from "react-icons/io5";
import "../styles/sifaris.css";

const requestOneSignalPermission = async () => {
    try {
        if (!window.OneSignalDeferred) {
            return {
                granted: false,
                state: "sdk_missing"
            };
        }

        return await new Promise((resolve) => {
            let resolved = false;

            const safeResolve = (data) => {
                if (!resolved) {
                    resolved = true;
                    resolve(data);
                }
            };

            // ⛔ safety timeout (SDK donarsa belə çıxır)
            setTimeout(() => {
                safeResolve( {
                    granted: false, state: "timeout"
                });
            }, 5000);

            window.OneSignalDeferred.push(async function (OneSignal) {
                try {
                    const isSupported = OneSignal.Notifications.isPushSupported();

                    if (!isSupported) {
                        safeResolve( {
                            granted: false, state: "unsupported"
                        });
                        return;
                    }

                    if (OneSignal.Notifications.permission === true) {
                        safeResolve( {
                            granted: true, state: "granted"
                        });
                        return;
                    }

                    await OneSignal.Notifications.requestPermission();

                    const granted = OneSignal.Notifications.permission === true;

                    safeResolve( {
                        granted,
                        state: granted ? "granted": "denied",
                    });
                } catch (e) {
                    safeResolve( {
                        granted: false, state: "error"
                    });
                }
            });
        });
    } catch (error) {
        console.error("OneSignal error:", error);
        return {
            granted: false, state: "error"
        };
    }
};

const isIOS = () => {
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
};

const isInStandaloneMode = () => {
    return (
        window.navigator.standalone === true ||
        window.matchMedia("(display-mode: standalone)").matches
    );
};

const AppModal = ({
    open,
    title = "Diqqət",
    message = "",
    type = "info",
    buttonText = "Bağla",
    onClose,
}) => {
    if (!open) return null;

    return (
        <div className="sq-modal-overlay">
            <div className="sq-alert-modal">
                <button className="sq-close-btn" onClick={onClose} type="button">
                    <IoClose size={22} />
                </button>

                <h3 className={`sq-alert-title sq-alert-${type}`}>{title}</h3>
                <p className="sq-alert-message" style={ { whiteSpace: "pre-line" }}>
                    {message}
                </p>

                <button className="sq-alert-button" onClick={onClose} type="button">
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

const PermissionScreen = () => {
    const navigate = useNavigate();
    const [modalOpen,
        setModalOpen] = useState(false);
    const [modalConfig,
        setModalConfig] = useState( {
            title: "",
            message: "",
            type: "info",
        });
    const [iosGuideShown,
        setIosGuideShown] = useState(false);

    const showModal = ({
        title, message, type = "info"
    }) => {
        setModalConfig({
            title, message, type
        });
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);

        if (iosGuideShown) {
            setIosGuideShown(false);
            localStorage.setItem("sifarisPermissionCompleted", "true");
            navigate("/sifaris/order-group", {
                replace: true
            });
        }
    };

    const syncOneSignalSubscriptionToUser = async () => {
        try {
            const userId = localStorage.getItem("id");
            if (!userId || !window.OneSignalDeferred) return;

            window.OneSignalDeferred.push(async function (OneSignal) {
                const subscriptionId = OneSignal.User?.PushSubscription?.id;

                if (subscriptionId) {
                    const {
                        updateUser
                    } = await import("../api");
                    await updateUser(userId, {
                        oneSignal: subscriptionId,
                        platform: "web",
                    });
                }
            });
        } catch (error) {
            console.error("OneSignal subscription sync xətası:",
                error);
        }
    };

    const handleNotifications = async () => {
        let result = {
            granted: false
        };

        try {
            if (isIOS() && !isInStandaloneMode()) {
                setIosGuideShown(true);
                showModal( {
                    title: "📱 iOS Bildirişləri",
                    message:
                    "1. Safari → Share\n2. Add to Home Screen\n3. Tətbiqi aç\n4. Davam et",
                    type: "info",
                });

                return; // iOS guide göstərilir
            }

            result = await requestOneSignalPermission();

            if (result?.granted) {
                await syncOneSignalSubscriptionToUser();
            }
        } catch (e) {
            console.error("permission flow error:", e);
        } finally {
            // 🔥 HƏR HALDA BURDAN KEÇİŞ OLUR
            localStorage.setItem("sifarisPermissionCompleted", "true");
            navigate("/sifaris/order-group", {
                replace: true
            });
        }

        if (!result?.granted) {
            showModal( {
                title: "Bildirişlər",
                message: "Bildiriş icazəsi verilmədi. Amma davam edirsiniz.",
                type: "info",
            });
        }
    };

    return (
        <>
            <div className="sq-page">
                <div className="sq-permission-card">
                    <div className="sq-permission-image-wrap">
                        <img
                        src="/notification.png"
                        alt="Bildirişlər"
                        className="sq-permission-image"
                        />
                </div>

                <h1 className="sq-title">Bildirişlər</h1>

                <p className="sq-subtitle sq-permission-text">
                    Sifariş statusu, çatdırılma gedişatı və vacib yeniliklər barədə sizi
                    vaxtında məlumatlandırmaq üçün bizə bildiriş icazəsi lazımdır.
                </p>

                <button
                    type="button"
                    className="sq-primary-btn"
                    onClick={handleNotifications}
                    >
                    Davam et
                </button>
            </div>
        </div>

        <AppModal
            open={modalOpen}
            title={modalConfig.title}
            message={modalConfig.message}
            type={modalConfig.type}
            onClose={closeModal}
            />
    </>
);
};

export default PermissionScreen;
